// MUI typography:
var typography = {
  fontFamily: ['Helvetica', "'Helvetica Neue'", 'Roboto', "'Segoe UI'", '-apple-system', 'BlinkMacSystemFont', 'sans serif'].join(', '),
  fontSize: 14,
  useNextVariants: true
};
export default typography;